/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  useMemo,
  useRef,
  useEffect,
} from 'react';
import { css, jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column } from '@chameleoncreator/creator-ui';
import Image from 'components/lib/Image';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import Container from 'components/Layouts/ContainerLogical';
import Media from 'components/lib/Media';
import Video from 'components/lib/Video';
import SVG from 'components/lib/SVG';
import { interactionContext } from './interactionContext';
import { Block } from '@chameleoncreator/creator-app';
import getBlockById from 'services/apiHelpers/getBlockById';
import IELayout from 'components/Layouts/IELayout';
import resolveProps from 'services/resolveProps';
import ResultsPageContent from './ResultsPageContent';
import ResultsPageMedia from './ResultsPageMedia';
// import { setScore, getScorePercent, getDummyScore } from 'services/scoring';
import { useSelector } from 'react-redux';
import ResultsPageResult from './ResultsPageResult';
import useIntersectionObserver from 'hooks/useIntersectionObserver';
import {
  getScore,
  getScoreRaw,
  getAllScoringInteractions,
} from 'services/scoring';

import { exportedExitProps } from 'components/lib/Scorm/SCORM';

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const Components = {
  Row,
  Column,
  Text: EditableText,
  Image,
  TwoColumnLayout: TwoColumnLayout,
  SingleColumnLayout: SingleColumnLayout,
  ContinueButton: ContinueBtn,
  Video,
  SVG,
  Media,
  ResultsPageContent,
  ResultsPageContentPassed: ({ children, ...props }) => children[0],
  ResultsPageContentFailed: ({ children, ...props }) => children[0],
  ResultsPageResult,
  ResultsPageMedia,
  ...IELayout(interactionContext),
};

const ResultsPageDisplay = props => {
  const interactionBlock = getBlockById(props.blockId);

  const [displayPassFailContent, setDisplayPassFailContent] = useState(
    'passed'
  );

  const { scormSettings } = useSelector((state: any) => state);
  const { passMark } = scormSettings;
  const hasScoringInteractions = !!getAllScoringInteractions().length;
  const { scoreRaw, scorePercent, passed } = exportedExitProps.exitProps;
  const score = hasScoringInteractions ? scorePercent.toFixed() : 100;
  const { entry, init } = useIntersectionObserver(true);

  useEffect(() => {
    init([document.querySelector(`#i${interactionBlock.id}`)], {
      threshold: 0.5,
    });
  }, []);

  useEffect(() => {
    parent[`displayPassFailContent${interactionBlock.id}`] = passedFailed => {
      setDisplayPassFailContent(passedFailed);
    };
  });

  const container = (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <interactionContext.Provider
        value={{
          ...interactionBlock,
          displayPassFailContent,
          score,
          passed,
        }}
      >
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </interactionContext.Provider>
    </Container>
  );

  return window.dev()
    ? container
    : useMemo(() => {
        // console.log('resultsPage renders');
        return container;
      }, [
        props.isOpen,
        displayPassFailContent,
        score,
        passed,
        interactionBlock.props.lockDown,
      ]);
};

export default ResultsPageDisplay;
